<template>
    <div>
        <limitless-page-header>
            <template #header-elements>
                <limitless-page-header-button @click="$router.push({ name: 'shipping.label_batch_list' })" icon="icon-circle-left2">Tillbaka till lista</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div v-if="!initialized && busy_loading" class="content">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div v-else-if="!not_found && labelbatch" class="content" style="padding-bottom: 6rem;">
            <div class="card">
                <div class="card-body">
                    <form>
                        <ValidationObserver ref="labelbatchform">
                            <div class="row">
                                <div class="col-lg-3">
                                    <select-with-validation
                                        vid="status_id"
                                        component="label-batch-status-filter"
                                        v-model="labelbatch.status_id"
                                        :reduce="(opt) => opt.id"
                                        disabled
                                    ></select-with-validation>
                                </div>
                            </div>
                        </ValidationObserver>
                    </form>
                </div>
                <div class="card-footer text-right">
<!--                    <limitless-button ref="btnsavelabelbatch" type="button" @click="saveLabelbatch" icon="icon-floppy-disk" :busy="busy_saving">Spara</limitless-button>-->
                    <limitless-button ref="btnsavelabelbatch" type="button" @click="closeBatch" icon="icon-floppy-disk" :busy="busy_saving">Avsluta batch</limitless-button>
                </div>
            </div>

            <rednax-datatable
                :url="'/vue/shipping/label_batch/items'"
                :columns="table_columns"
                :filter="{ label_batch_id: id }"
                sort-by="id"
                sort-order="desc"
                @rowclick="rowClick"
                :per-page="100"
            >
                <template #cell_batchable="{ row }">
                    <div v-if="row.batchable_type === 'App\\Models\\ProdOrder' || row.batchable_type === 'App\\Models\\ReturnOrder'">
                        <div v-if="statuses[row.batchable.StatusID]" class="badge text-white" :class="['badge-' + statuses[row.batchable.StatusID].class]">{{ statuses[row.batchable.StatusID].name }}</div>
                    </div>
                </template>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import getError from '@services/ErrorHelper';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import BackendRepository from '@services/repositories/BackendRepository';
import { keyBy } from 'lodash';

export default {
    name: 'LabelBatchEdit',
    components: {
        SelectWithValidation,
        LimitlessButton,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
    },
    props: {
        id: {
            type: [String, Number],
            required: true,
        },
    },
    data: () => ({
        not_found: false,
        initialized: false,
        busy_loading: true,
        busy_saving: false,
        labelbatch: null,
        table_columns: [
            {
                data: 'batchable_id',
                header: 'ID',
                sortable: true,
            },
            {
                data: 'batchable_type',
                header: 'Typ',
                sortable: true,
            },
            {
                data: 'batchable',
                header: 'Status',
                sortable: false,
            },
        ],
        card_order_statuses: null,
        statuses: null,
    }),
    mounted() {
        this.init();
    },
    watch: {
        id() {
            this.init();
        },
    },
    methods: {
        init() {
            this.getLabelbatch();
            BackendRepository.getStatuses().then((res) => {
                this.statuses = keyBy(res, 'id');
            });
        },
        getLabelbatch() {
            this.busy_loading = true;
            apiClient.get('/vue/shipping/label_batch/' + this.id)
                .then((response) => {
                    this.labelbatch = response.data;
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy_loading = false;
                });
        },
        closeBatch() {
            this.labelbatch.status_id = 900;
            this.saveLabelbatch();
        },
        async saveLabelbatch() {
            const isValid = await this.$refs.labelbatchform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/shipping/label_batch/' + this.labelbatch.id, { ...this.labelbatch })
                    .then((response) => {
                        if (parseInt(this.id, 10) !== parseInt(response.data.id, 10)) {
                            this.$router.push({ name: 'address_lists.edit', params: { id: response.data.id } });
                        }
                        this.labelbatch = response.data;
                        this.$refs.btnsavelabelbatch.triggerSaved();
                    }).catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.labelbatchform.setErrors(parsederror);
                        }
                        this.$refs.btnsavelabelbatch.triggerFailed();
                    }).finally(() => {
                        this.busy_saving = false;
                    });
            } else {
                this.$refs.btnsavelabelbatch.triggerFailed();
            }
        },
        rowClick(data, event) {
            let route = null;
            if (data.batchable_type === 'App\\Models\\ProdOrder') {
                route = { name: 'prodorders.edit', params: { id: data.batchable_id } };
            } else if (data.batchable_type === 'App\\Models\\ReturnOrder') {
                route = { name: 'returnorder.edit', params: { id: data.batchable_id } };
            } else if (data.batchable_type === 'App\\Models\\CardOrder') {
                route = { name: 'cardorders.edit', params: { id: data.batchable_id } };
            } else if (data.batchable_type === 'App\\Models\\CardOrderDeliveryAddress') {
                // Todo: get card order id for route
                // route = { name: 'cardorders.edit', params: { id: 'xxxx' } };
            } else if (data.batchable_type === 'App\\Models\\RecipientLabel') {
                route = { name: 'address_lists.edit', params: { id: data.batchable_id } };
            }
            if (route) {
                if (event.metaKey === true || event.ctrlKey === true) {
                    const resolvedRoute = this.$router.resolve(route);
                    window.open(resolvedRoute.href, '_blank').focus();
                } else {
                    this.$router.push(route);
                }
            }
        },
    },
};

</script>
